import api, { fetchData } from './api';
import Paginacao from '../types/paginacao';
import Supplier from '../types/supplier';

export interface SupplierApiResponse {
  data: Supplier;
  messages: any; 
}

export const getSuppliersPaginated = async (
    paginacao: Paginacao
  ) => {
    try {
      const endpoint: string = '/Supplier/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
      };
  
      const response = await fetchData<Supplier>(endpoint, params);
  
      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de suppliers:', error);
      throw error;
    }
};
  
  export const getSupplierById = async (id: number) => {
    try {
      const response = await api.get(`/Supplier/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar supplier com ID ${id}`, error);
      throw error;
    }
  };

  export const deleteSupplier = async (id: number) => {
    try {
      const response = await api.delete(`/Supplier/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao excluir supplier com ID ${id}`, error);
      throw error;
    }
  };
  
  export const getSuppliers = async () => {
    try {
      const endpoint: string = 'Supplier/all';
      const response = await fetchData<Supplier>(endpoint, {});
      return response;
    } catch (error) {
      console.error(`Erro ao buscar supplier`, error);
      throw error;
    }
  };
  
  export const createSupplier = async (supplier: Supplier) => {
    try {
      const response = await api.post('Supplier', supplier);
      console.log('Response createSupplier:', response);
      console.log('Response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar supplier:', error);
      throw error;
    }
  };
  
  export const updateSupplier = async (id: number, supplier: Supplier) => {
    try {
      const response = await api.put(`/Supplier/update/${id}`, supplier);
      console.log('Response updateSupplier:', response);
      console.log('Response data:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error updating supplier:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  };